import { Link } from 'react-router-dom';
import { Combine, FileArchive, Minimize2 } from 'lucide-react';
import { Card } from '../../../components/ui/Card';

const TOOLS = [
  {
    to: '/tools/compress',
    title: 'Сжатие PDF',
    description: 'Уменьшите размер PDF, выбрав уровень сжатия.',
    icon: Minimize2,
  },
  {
    to: '/tools/split',
    title: 'Разделение PDF',
    description: 'Извлеките нужные страницы или разбейте на части.',
    icon: FileArchive,
  },
  {
    to: '/tools/merge',
    title: 'Объединение PDF',
    description: 'Склейте несколько файлов в один с нужным порядком.',
    icon: Combine,
  },
];

export function ToolsIndexPage() {
  return (
    <div className="flex flex-col gap-4">
      <div>
        <h1 className="text-2xl font-semibold">Инструменты PDF</h1>
        <p className="mt-1 text-sm text-text-muted">
          Быстрые операции без отправки файлов в очередь OCR.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {TOOLS.map((t) => (
          <Link key={t.to} to={t.to} className="block">
            <Card className="flex h-full flex-col gap-2 transition-all hover:-translate-y-0.5 hover:shadow-lifted">
              <div className="flex h-12 w-12 items-center justify-center rounded-[14px] bg-brand-gradient text-white">
                <t.icon size={22} />
              </div>
              <h3 className="mt-1 text-lg font-semibold">{t.title}</h3>
              <p className="text-sm text-text-muted">{t.description}</p>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
